/**
 * These are the feature flag definitions. You can configure them for each environment
 * by logging into Flagsmith. 
 */

export const FEATURE_FLAGS = {
  SHOW_SIGNUP_LOGIN_NAVTAB: "show_signup_login_navtab",
};
